




import Vue from 'vue'
import { IPayment } from '@/models'
import { createNamespacedHelpers } from 'vuex'
import { STORE_MODULES, ACTIONS_ORDER } from '@/enums'

const { mapActions } = createNamespacedHelpers(STORE_MODULES.ORDER)
const UPDATE_INTERVAL = 5 /* s */ * 1e3

export default Vue.extend({
    name: 'PaymentUpdater',

    model: {
        prop: 'payment',
        event: 'update:payment',
    },

    props: {
        payment: {
            type: Object as () => IPayment,
            required: true,
        },
    },

    data: () => ({ isActive: true }),

    created() {
        this.scheduleNextUpdate()
    },

    beforeDestroy() {
        this.isActive = false
    },

    methods: {
        ...mapActions({
            fetchPayment: ACTIONS_ORDER.FETCH_PAYMENT,
        }),

        scheduleNextUpdate() {
            if (!this.isActive) return

            setTimeout(this.update, UPDATE_INTERVAL)
        },

        async update() {
            const updatedPayment = await this.fetchPayment(this.payment.paymentID)

            this.$emit('update:payment', updatedPayment)
            this.scheduleNextUpdate()
        },
    },
})
